
import { EnterpriseAiInsightsList } from "../Model/AiInsightObjects";
import { REVIEW_AI_INSIGHTS } from "../Reducers/reviewAiInsightsReducer";
import { fetchReviewAiInsights } from "../Util/queries";

export const getReviewAiInsights = (timeframe = "this_month") => async (dispatch) => {
    try {
        const response = await fetchReviewAiInsights(timeframe);
        dispatch({
            type: REVIEW_AI_INSIGHTS,
            payload: new EnterpriseAiInsightsList(response.data, timeframe)
        });
    } catch (error) {
        console.error(error);
        dispatch({
            type: REVIEW_AI_INSIGHTS,
            payload: new EnterpriseAiInsightsList(null, timeframe)
        });  
    }
}
